import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import SSO from "./components/sso/SSO"
import { BrowserRouter, BrowserRouter as Router, useNavigate } from 'react-router-dom';
// import config from "./components/sso/config";
import {Provider} from 'react-redux';
import store from '../src/components/redux/store';
import {persistor} from '../src/components/redux/store';
//import 'semantic-ui-css/semantic.min.css'
import 'bootstrap/dist/css/bootstrap.css';
import "./components/styles/ag-grid.scss";
import 'ag-grid-enterprise';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';


import { PersistGate } from 'redux-persist/integration/react'
import { LicenseManager } from  'ag-grid-enterprise'
import './fonts/emerson-fonts.scss';
import { Suspense } from 'react';
import Loader from './components/loader';
import './components/translation/i18n';
import { Auth0Provider } from '@auth0/auth0-react';
import config from './utils/config';
// import {createMemoryHistory} from 'history';
LicenseManager.setLicenseKey("CompanyName=Emerson Process Management LLLP,LicensedGroup=Emerson Automation Solutions Sales and Sales Operations,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=4,LicensedProductionInstancesCount=2,AssetReference=AG-024956,ExpiryDate=23_March_2023_[v2]_MTY3OTUyOTYwMDAwMA==d9fd5836e6dfafeebe6b151686472920");
localStorage.removeItem('NR')
//import './components/styles/common.scss';
// let history = createMemoryHistory()


const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  return (
    <Auth0Provider
      domain= {config.AUTH0_DOMAIN}
      clientId={config.AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        ui_locales: 'en',
      }}
      onRedirectCallback={(appState) => {
        navigate(appState?.returnTo || window.location.origin);
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
};


ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={<Loader />}>
      <BrowserRouter>
        <AuthProvider>
          <SSO />
        </AuthProvider>
      </BrowserRouter>
    </Suspense>
  </Provider>,
  document.getElementById("root")
);


// import './index.scss';
// import React, { Suspense } from 'react';
// import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react'
// import store from '../src/components/redux/store';
// import SSO from "./components/sso/SSO"
// import { persistor } from '../src/components/redux/store';
// import 'bootstrap/dist/css/bootstrap.css';
// import "./components/styles/ag-grid.scss";
// import 'ag-grid-enterprise';
// import { LicenseManager } from 'ag-grid-enterprise'
// import 'ag-grid-community/dist/styles/ag-grid.css';
// import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
// import './fonts/emerson-fonts.scss';
// import Loader from './components/loader';


// LicenseManager.setLicenseKey("CompanyName=Emerson Process Management LLLP,LicensedGroup=Emerson Automation Solutions Sales and Sales Operations,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=4,LicensedProductionInstancesCount=2,AssetReference=AG-024956,ExpiryDate=23_March_2023_[v2]_MTY3OTUyOTYwMDAwMA==d9fd5836e6dfafeebe6b151686472920");
// localStorage.removeItem('NR')

// ReactDOM.createRoot(document.getElementById('root')).render(
//   <Provider store={store}>
//     {/* <PersistGate persistor={persistor}> */}
//       <Suspense fallback={<Loader />} >
//         <BrowserRouter>
//           <SSO />
//         </BrowserRouter>
//       </Suspense>
//     {/* </PersistGate> */}
//   </Provider>
// );
